import logo from './logo.svg';
import './App.css';
import axios from 'axios';


function App() {

    axios.get(`https://partners.1c-bitrix.ru/catalog.php?type=b24`,
        {
            mode: 'no-cors',
            headers: {
                'Access-Control-Allow-Origin': '*',
                "Access-Control-Allow-Methods": "GET",
                'Access-Control-Allow-Credentials': 'true',
                "Accept": 'application/json',
                'Content-Type': 'application/json',
            },
            withCredentials: true,
            credentials: 'same-origin',
            crossdomain: true
        })
        .then(response => response.json())
        .then(data => console.log(data))

    return (
        <div className="container">
            <div role="tabpanel" className="tab-pane active" id="cloud">
                <div className="tariffs-wrapper">
                    <table className="table table-responsive d-none d-md-block d-none d-sm-block tariffs ">
                        <thead>
                            <tr>
                                <th className="red" style={{ borderLeft: '0px' }}>Тарифы</th>
                                <th style={{ borderTop: '1px solid #eeedf2' }}>Старт+</th>
                                <th style={{ borderTop: '1px solid #eeedf2' }}>Задачи+</th>
                                <th style={{ borderTop: '1px solid #eeedf2' }}>CRM+</th>
                                <th style={{ borderTop: '1px solid #eeedf2' }}>Команда</th>
                                <th style={{ borderTop: '1px solid #eeedf2' }}>Компания</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th scope="row">
                                    Цена за месяц <br /><select className="form-control additional_price_control">
                                        <option data-class="PRICEFORMONTH" value="PRICEFORMONTH">на 1 месяц</option>
                                        <option data-class="PRICEFORTHREEMONTHS" value="PRICEFORTHREEMONTHS">на 3 месяца
                                </option>
                                        <option data-class="PRICEFORHALFAYEAR" value="PRICEFORHALFAYEAR">на полгода
                                </option>
                                        <option data-class="PRICEFORYEAR" value="PRICEFORYEAR">на год</option>
                                        <option data-class="PRICEFORTWOYEARS" value="PRICEFORTWOYEARS">на 2 года
                                </option>
                                    </select></th>
                                <td className="price_col"><span className="additional_wrapper"><span className="real_price">594
                                    ₽</span><br /><span className="old_cena">990 ₽</span></span>
                                    <div className="prices_box"><span className="additional PRICEFORMONTH"><span
                                        className="real_price">990 ₽</span></span><span
                                            className="additional PRICEFORTHREEMONTHS"><span className="real_price">990
                                        ₽</span></span><span className="additional PRICEFORYEAR"><span
                                            className="real_price">693 ₽</span><br /><span className="old_cena">990
                                        ₽</span></span><span className="additional PRICEFORTWOYEARS"><span
                                            className="real_price">594 ₽</span><br /><span className="old_cena">990
                                        ₽</span></span></div>
                                </td>
                                <td className="price_col"><span className="additional_wrapper"><span className="real_price">1 794
                                    ₽</span><br /><span className="old_cena">2 990 ₽</span></span>
                                    <div className="prices_box"><span className="additional PRICEFORMONTH"><span
                                        className="real_price">2 990 ₽</span></span><span
                                            className="additional PRICEFORTHREEMONTHS"><span className="real_price">2 990
                                        ₽</span></span><span className="additional PRICEFORYEAR"><span
                                            className="real_price">2 093 ₽</span><br /><span className="old_cena">2 990
                                        ₽</span></span><span className="additional PRICEFORTWOYEARS"><span
                                            className="real_price">1 794 ₽</span><br /><span className="old_cena">2 990
                                        ₽</span></span></div>
                                </td>
                                <td className="price_col"><span className="additional_wrapper"><span className="real_price">1 794
                                    ₽</span><br /><span className="old_cena">2 990 ₽</span></span>
                                    <div className="prices_box"><span className="additional PRICEFORMONTH"><span
                                        className="real_price">2 990 ₽</span></span><span
                                            className="additional PRICEFORTHREEMONTHS"><span className="real_price">2 990
                                        ₽</span></span><span className="additional PRICEFORYEAR"><span
                                            className="real_price">2 093 ₽</span><br /><span className="old_cena">2 990
                                        ₽</span></span><span className="additional PRICEFORTWOYEARS"><span
                                            className="real_price">1 794 ₽</span><br /><span className="old_cena">2 990
                                        ₽</span></span></div>
                                </td>
                                <td className="price_col"><span className="additional_wrapper"><span className="real_price">3 594
                                    ₽</span><br /><span className="old_cena">5 990 ₽</span></span>
                                    <div className="prices_box"><span className="additional PRICEFORMONTH"><span
                                        className="real_price">5 990 ₽</span></span><span
                                            className="additional PRICEFORTHREEMONTHS"><span className="real_price">5 990
                                        ₽</span></span><span className="additional PRICEFORYEAR"><span
                                            className="real_price">4 193 ₽</span><br /><span className="old_cena">5 990
                                        ₽</span></span><span className="additional PRICEFORTWOYEARS"><span
                                            className="real_price">3 594 ₽</span><br /><span className="old_cena">5 990
                                        ₽</span></span></div>
                                </td>
                                <td className="price_col"><span className="additional_wrapper"><span className="real_price">7 194
                                    ₽</span><br /><span className="old_cena">11 990 ₽</span></span>
                                    <div className="prices_box"><span className="additional PRICEFORMONTH"><span
                                        className="real_price">11 990 ₽</span></span><span
                                            className="additional PRICEFORTHREEMONTHS"><span className="real_price">11 990
                                        ₽</span></span><span className="additional PRICEFORYEAR"><span
                                            className="real_price">8 393 ₽</span><br /><span className="old_cena">11 990
                                        ₽</span></span><span className="additional PRICEFORTWOYEARS"><span
                                            className="real_price">7 194 ₽</span><br /><span className="old_cena">11 990
                                        ₽</span></span></div>
                                </td>
                            </tr>
                            <tr>
                                <th scope="row">Пользователи</th>
                                <td>2</td>
                                <td>24</td>
                                <td>6</td>
                                <td>50</td>
                                <td>∞</td>
                            </tr>
                            <tr>
                                <th scope="row">CRM-Маркетинг&#65279;</th>
                                <td><i className="fa fa-minus-circle" aria-hidden="true"></i></td>
                                <td><i className="fa fa-minus-circle" aria-hidden="true"></i></td>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i></td>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i><i className="fa fa-plus-circle"
                                    aria-hidden="true"></i></td>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i><i className="fa fa-plus-circle"
                                    aria-hidden="true"></i><i className="fa fa-plus-circle" aria-hidden="true"></i></td>
                            </tr>
                            <tr>
                                <th scope="row">Сквозная аналитика&#65279;</th>
                                <td><i className="fa fa-minus-circle" aria-hidden="true"></i></td>
                                <td><i className="fa fa-minus-circle" aria-hidden="true"></i></td>
                                <td><i className="fa fa-minus-circle" aria-hidden="true"></i></td>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i><i className="fa fa-plus-circle"
                                    aria-hidden="true"></i></td>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i><i className="fa fa-plus-circle"
                                    aria-hidden="true"></i><i className="fa fa-plus-circle" aria-hidden="true"></i></td>
                            </tr>
                            <tr>
                                <th scope="row">Центр продаж&#65279;</th>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i><i className="fa fa-plus-circle"
                                    aria-hidden="true"></i></td>
                                <td><i className="fa fa-minus-circle" aria-hidden="true"></i></td>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i><i className="fa fa-plus-circle"
                                    aria-hidden="true"></i></td>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i><i className="fa fa-plus-circle"
                                    aria-hidden="true"></i></td>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i><i className="fa fa-plus-circle"
                                    aria-hidden="true"></i><i className="fa fa-plus-circle" aria-hidden="true"></i></td>
                            </tr>
                            <tr>
                                <th scope="row">Место в облаке</th>
                                <td>10 Гб</td>
                                <td>50 ГБ</td>
                                <td>50 ГБ</td>
                                <td>100 ГБ</td>
                                <td>∞</td>
                            </tr>
                            <tr>
                                <th scope="row">Запись звонков</th>
                                <td>500</td>
                                <td>100</td>
                                <td>∞</td>
                                <td>∞</td>
                                <td>∞</td>
                            </tr>
                            <tr>
                                <th scope="row">CRM&#65279;</th>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i><i className="fa fa-plus-circle"
                                    aria-hidden="true"></i></td>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i></td>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i><i className="fa fa-plus-circle"
                                    aria-hidden="true"></i></td>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i><i className="fa fa-plus-circle"
                                    aria-hidden="true"></i></td>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i><i className="fa fa-plus-circle"
                                    aria-hidden="true"></i><i className="fa fa-plus-circle" aria-hidden="true"></i></td>
                            </tr>
                            <tr>
                                <th scope="row">Задачи и проекты&#65279;</th>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i><i className="fa fa-plus-circle"
                                    aria-hidden="true"></i></td>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i><i className="fa fa-plus-circle"
                                    aria-hidden="true"></i></td>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i><i className="fa fa-plus-circle"
                                    aria-hidden="true"></i></td>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i><i className="fa fa-plus-circle"
                                    aria-hidden="true"></i></td>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i><i className="fa fa-plus-circle"
                                    aria-hidden="true"></i><i className="fa fa-plus-circle" aria-hidden="true"></i></td>
                            </tr>
                            <tr>
                                <th scope="row">Офис, совместная работа&#65279;</th>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i></td>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i><i className="fa fa-plus-circle"
                                    aria-hidden="true"></i></td>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i><i className="fa fa-plus-circle"
                                    aria-hidden="true"></i></td>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i><i className="fa fa-plus-circle"
                                    aria-hidden="true"></i></td>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i><i className="fa fa-plus-circle"
                                    aria-hidden="true"></i><i className="fa fa-plus-circle" aria-hidden="true"></i></td>
                            </tr>
                            <tr>
                                <th scope="row">Сайты и лендинги&#65279;</th>
                                <td>10</td>
                                <td>1</td>
                                <td>10</td>
                                <td>10</td>
                                <td>∞</td>
                            </tr>
                            <tr>
                                <th scope="row">Магазин&#65279;</th>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i><i className="fa fa-plus-circle"
                                    aria-hidden="true"></i></td>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i></td>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i><i className="fa fa-plus-circle"
                                    aria-hidden="true"></i></td>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i><i className="fa fa-plus-circle"
                                    aria-hidden="true"></i></td>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i><i className="fa fa-plus-circle"
                                    aria-hidden="true"></i><i className="fa fa-plus-circle" aria-hidden="true"></i></td>
                            </tr>
                            <tr>
                                <th scope="row">Контакт-Центр&#65279;</th>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i><i className="fa fa-plus-circle"
                                    aria-hidden="true"></i></td>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i></td>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i><i className="fa fa-plus-circle"
                                    aria-hidden="true"></i></td>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i><i className="fa fa-plus-circle"
                                    aria-hidden="true"></i></td>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i><i className="fa fa-plus-circle"
                                    aria-hidden="true"></i><i className="fa fa-plus-circle" aria-hidden="true"></i></td>
                            </tr>
                            <tr>
                                <th scope="row"></th>
                                <td>
                                    <span><a href="/uslugi/kupit-licenziju-bitrix24/"
                                        className="btn btn-buy">Подробнее</a></span>
                                </td>
                                <td>
                                    <span><a href="/uslugi/kupit-licenziju-bitrix24/"
                                        className="btn btn-buy">Подробнее</a></span>
                                </td>
                                <td>
                                    <span><a href="/uslugi/kupit-licenziju-bitrix24/"
                                        className="btn btn-buy">Подробнее</a></span>
                                </td>
                                <td>
                                    <span><a href="/uslugi/kupit-licenziju-bitrix24/"
                                        className="btn btn-buy">Подробнее</a></span>
                                </td>
                                <td>
                                    <span><a href="/uslugi/kupit-licenziju-bitrix24/"
                                        className="btn btn-buy">Подробнее</a></span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <table className="table table-responsive d-lg-none d-xl-none d-md-none d-lg-none d-xl-none ">
                        <thead>
                            <tr>
                                <th>Старт+</th>
                                <th><select className="form-control additional_price_control">
                                    <option data-class="PRICEFORMONTH" value="PRICEFORMONTH">на 1 месяц</option>
                                    <option data-class="PRICEFORTHREEMONTHS" value="PRICEFORTHREEMONTHS">на 3 месяца
                                </option>
                                    <option data-class="PRICEFORHALFAYEAR" value="PRICEFORHALFAYEAR">на полгода
                                </option>
                                    <option data-class="PRICEFORYEAR" value="PRICEFORYEAR">на год</option>
                                    <option data-class="PRICEFORTWOYEARS" value="PRICEFORTWOYEARS">на 2 года
                                </option>
                                </select></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th scope="row"><span className="custom_labels-header">Цена за месяц</span></th>
                                <td className="price_col"><span className="additional_wrapper"><span className="real_price">594
                                    ₽</span><br /><span className="old_cena">990 ₽</span></span>
                                    <div className="prices_box"><span className="additional PRICEFORMONTH"><span
                                        className="real_price">990 ₽</span></span><span
                                            className="additional PRICEFORTHREEMONTHS"><span className="real_price">990
                                        ₽</span></span><span className="additional PRICEFORYEAR"><span
                                            className="real_price">693 ₽</span><br /><span className="old_cena">990
                                        ₽</span></span><span className="additional PRICEFORTWOYEARS"><span
                                            className="real_price">594 ₽</span><br /><span className="old_cena">990
                                        ₽</span></span></div>
                                </td>
                            </tr>
                            <tr className="">
                                <th scope="row">Пользователи</th>
                                <td>2</td>
                            </tr>
                            <tr className="table__hidengs">
                                <th scope="row">CRM-Маркетинг&#65279;</th>
                                <td><i className="fa fa-minus-circle" aria-hidden="true"></i></td>
                            </tr>
                            <tr className="table__hidengs">
                                <th scope="row">Сквозная аналитика&#65279;</th>
                                <td><i className="fa fa-minus-circle" aria-hidden="true"></i></td>
                            </tr>
                            <tr className="table__hidengs">
                                <th scope="row">Центр продаж&#65279;</th>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i><i className="fa fa-plus-circle"
                                    aria-hidden="true"></i></td>
                            </tr>
                            <tr className="table__hidengs">
                                <th scope="row">Место в облаке</th>
                                <td>10 Гб</td>
                            </tr>
                            <tr className="table__hidengs">
                                <th scope="row">Запись звонков</th>
                                <td>500</td>
                            </tr>
                            <tr className="">
                                <th scope="row">CRM&#65279;</th>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i><i className="fa fa-plus-circle"
                                    aria-hidden="true"></i></td>
                            </tr>
                            <tr className="">
                                <th scope="row">Задачи и проекты&#65279;</th>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i><i className="fa fa-plus-circle"
                                    aria-hidden="true"></i></td>
                            </tr>
                            <tr className="">
                                <th scope="row">Офис, совместная работа&#65279;</th>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i></td>
                            </tr>
                            <tr className="table__hidengs">
                                <th scope="row">Сайты и лендинги&#65279;</th>
                                <td>10</td>
                            </tr>
                            <tr className="table__hidengs">
                                <th scope="row">Магазин&#65279;</th>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i><i className="fa fa-plus-circle"
                                    aria-hidden="true"></i></td>
                            </tr>
                            <tr className="table__hidengs">
                                <th scope="row">Контакт-Центр&#65279;</th>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i><i className="fa fa-plus-circle"
                                    aria-hidden="true"></i></td>
                            </tr>
                            <tr>
                                <td colSpan="2"><a href="#" className="table__hidengs-toggle">Показать все
                                характеристики</a></td>
                            </tr>
                            <tr>
                                <td colSpan="2"><button type="button" className="btn btn-buy" data-target="#advanced"
                                    data-form-field-type="Подробнее :Тариф Б24 Старт+, "
                                    data-toggle="modal">Подробнее</button></td>
                            </tr>
                        </tbody>
                    </table>
                    <table className="table table-responsive d-lg-none d-xl-none d-md-none d-lg-none d-xl-none ">
                        <thead>
                            <tr>
                                <th>Задачи+</th>
                                <th><select className="form-control additional_price_control">
                                    <option data-class="PRICEFORMONTH" value="PRICEFORMONTH">на 1 месяц</option>
                                    <option data-class="PRICEFORTHREEMONTHS" value="PRICEFORTHREEMONTHS">на 3 месяца
                                </option>
                                    <option data-class="PRICEFORHALFAYEAR" value="PRICEFORHALFAYEAR">на полгода
                                </option>
                                    <option data-class="PRICEFORYEAR" value="PRICEFORYEAR">на год</option>
                                    <option data-class="PRICEFORTWOYEARS" value="PRICEFORTWOYEARS">на 2 года
                                </option>
                                </select></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th scope="row"><span className="custom_labels-header">Цена за месяц</span></th>
                                <td className="price_col"><span className="additional_wrapper"><span className="real_price">1 794
                                    ₽</span><br /><span className="old_cena">2 990 ₽</span></span>
                                    <div className="prices_box"><span className="additional PRICEFORMONTH"><span
                                        className="real_price">2 990 ₽</span></span><span
                                            className="additional PRICEFORTHREEMONTHS"><span className="real_price">2 990
                                        ₽</span></span><span className="additional PRICEFORYEAR"><span
                                            className="real_price">2 093 ₽</span><br /><span className="old_cena">2 990
                                        ₽</span></span><span className="additional PRICEFORTWOYEARS"><span
                                            className="real_price">1 794 ₽</span><br /><span className="old_cena">2 990
                                        ₽</span></span></div>
                                </td>
                            </tr>
                            <tr className="">
                                <th scope="row">Пользователи</th>
                                <td>24</td>
                            </tr>
                            <tr className="table__hidengs">
                                <th scope="row">CRM-Маркетинг&#65279;</th>
                                <td><i className="fa fa-minus-circle" aria-hidden="true"></i></td>
                            </tr>
                            <tr className="table__hidengs">
                                <th scope="row">Сквозная аналитика&#65279;</th>
                                <td><i className="fa fa-minus-circle" aria-hidden="true"></i></td>
                            </tr>
                            <tr className="table__hidengs">
                                <th scope="row">Центр продаж&#65279;</th>
                                <td><i className="fa fa-minus-circle" aria-hidden="true"></i></td>
                            </tr>
                            <tr className="table__hidengs">
                                <th scope="row">Место в облаке</th>
                                <td>50 ГБ</td>
                            </tr>
                            <tr className="table__hidengs">
                                <th scope="row">Запись звонков</th>
                                <td>100</td>
                            </tr>
                            <tr className="">
                                <th scope="row">CRM&#65279;</th>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i></td>
                            </tr>
                            <tr className="">
                                <th scope="row">Задачи и проекты&#65279;</th>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i><i className="fa fa-plus-circle"
                                    aria-hidden="true"></i></td>
                            </tr>
                            <tr className="">
                                <th scope="row">Офис, совместная работа&#65279;</th>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i><i className="fa fa-plus-circle"
                                    aria-hidden="true"></i></td>
                            </tr>
                            <tr className="table__hidengs">
                                <th scope="row">Сайты и лендинги&#65279;</th>
                                <td>1</td>
                            </tr>
                            <tr className="table__hidengs">
                                <th scope="row">Магазин&#65279;</th>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i></td>
                            </tr>
                            <tr className="table__hidengs">
                                <th scope="row">Контакт-Центр&#65279;</th>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i></td>
                            </tr>
                            <tr>
                                <td colSpan="2"><a href="#" className="table__hidengs-toggle">Показать все
                                характеристики</a></td>
                            </tr>
                            <tr>
                                <td colSpan="2"><button type="button" className="btn btn-buy" data-target="#advanced"
                                    data-form-field-type="Подробнее :Тариф Б24 Задачи+, "
                                    data-toggle="modal">Подробнее</button></td>
                            </tr>
                        </tbody>
                    </table>
                    <table className="table table-responsive d-lg-none d-xl-none d-md-none d-lg-none d-xl-none ">
                        <thead>
                            <tr>
                                <th>CRM+</th>
                                <th><select className="form-control additional_price_control">
                                    <option data-class="PRICEFORMONTH" value="PRICEFORMONTH">на 1 месяц</option>
                                    <option data-class="PRICEFORTHREEMONTHS" value="PRICEFORTHREEMONTHS">на 3 месяца
                                </option>
                                    <option data-class="PRICEFORHALFAYEAR" value="PRICEFORHALFAYEAR">на полгода
                                </option>
                                    <option data-class="PRICEFORYEAR" value="PRICEFORYEAR">на год</option>
                                    <option data-class="PRICEFORTWOYEARS" value="PRICEFORTWOYEARS">на 2 года
                                </option>
                                </select></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th scope="row"><span className="custom_labels-header">Цена за месяц</span></th>
                                <td className="price_col"><span className="additional_wrapper"><span className="real_price">1 794
                                    ₽</span><br /><span className="old_cena">2 990 ₽</span></span>
                                    <div className="prices_box"><span className="additional PRICEFORMONTH"><span
                                        className="real_price">2 990 ₽</span></span><span
                                            className="additional PRICEFORTHREEMONTHS"><span className="real_price">2 990
                                        ₽</span></span><span className="additional PRICEFORYEAR"><span
                                            className="real_price">2 093 ₽</span><br /><span className="old_cena">2 990
                                        ₽</span></span><span className="additional PRICEFORTWOYEARS"><span
                                            className="real_price">1 794 ₽</span><br /><span className="old_cena">2 990
                                        ₽</span></span></div>
                                </td>
                            </tr>
                            <tr className="">
                                <th scope="row">Пользователи</th>
                                <td>6</td>
                            </tr>
                            <tr className="table__hidengs">
                                <th scope="row">CRM-Маркетинг&#65279;</th>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i></td>
                            </tr>
                            <tr className="table__hidengs">
                                <th scope="row">Сквозная аналитика&#65279;</th>
                                <td><i className="fa fa-minus-circle" aria-hidden="true"></i></td>
                            </tr>
                            <tr className="table__hidengs">
                                <th scope="row">Центр продаж&#65279;</th>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i><i className="fa fa-plus-circle"
                                    aria-hidden="true"></i></td>
                            </tr>
                            <tr className="table__hidengs">
                                <th scope="row">Место в облаке</th>
                                <td>50 ГБ</td>
                            </tr>
                            <tr className="table__hidengs">
                                <th scope="row">Запись звонков</th>
                                <td>∞</td>
                            </tr>
                            <tr className="">
                                <th scope="row">CRM&#65279;</th>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i><i className="fa fa-plus-circle"
                                    aria-hidden="true"></i></td>
                            </tr>
                            <tr className="">
                                <th scope="row">Задачи и проекты&#65279;</th>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i><i className="fa fa-plus-circle"
                                    aria-hidden="true"></i></td>
                            </tr>
                            <tr className="">
                                <th scope="row">Офис, совместная работа&#65279;</th>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i><i className="fa fa-plus-circle"
                                    aria-hidden="true"></i></td>
                            </tr>
                            <tr className="table__hidengs">
                                <th scope="row">Сайты и лендинги&#65279;</th>
                                <td>10</td>
                            </tr>
                            <tr className="table__hidengs">
                                <th scope="row">Магазин&#65279;</th>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i><i className="fa fa-plus-circle"
                                    aria-hidden="true"></i></td>
                            </tr>
                            <tr className="table__hidengs">
                                <th scope="row">Контакт-Центр&#65279;</th>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i><i className="fa fa-plus-circle"
                                    aria-hidden="true"></i></td>
                            </tr>
                            <tr>
                                <td colSpan="2"><a href="#" className="table__hidengs-toggle">Показать все
                                характеристики</a></td>
                            </tr>
                            <tr>
                                <td colSpan="2"><button type="button" className="btn btn-buy" data-target="#advanced"
                                    data-form-field-type="Подробнее :Тариф Б24 CRM+, "
                                    data-toggle="modal">Подробнее</button></td>
                            </tr>
                        </tbody>
                    </table>
                    <table className="table table-responsive d-lg-none d-xl-none d-md-none d-lg-none d-xl-none ">
                        <thead>
                            <tr>
                                <th>Команда</th>
                                <th><select className="form-control additional_price_control">
                                    <option data-class="PRICEFORMONTH" value="PRICEFORMONTH">на 1 месяц</option>
                                    <option data-class="PRICEFORTHREEMONTHS" value="PRICEFORTHREEMONTHS">на 3 месяца
                                </option>
                                    <option data-class="PRICEFORHALFAYEAR" value="PRICEFORHALFAYEAR">на полгода
                                </option>
                                    <option data-class="PRICEFORYEAR" value="PRICEFORYEAR">на год</option>
                                    <option data-class="PRICEFORTWOYEARS" value="PRICEFORTWOYEARS">на 2 года
                                </option>
                                </select></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th scope="row"><span className="custom_labels-header">Цена за месяц</span></th>
                                <td className="price_col"><span className="additional_wrapper"><span className="real_price">3 594
                                    ₽</span><br /><span className="old_cena">5 990 ₽</span></span>
                                    <div className="prices_box"><span className="additional PRICEFORMONTH"><span
                                        className="real_price">5 990 ₽</span></span><span
                                            className="additional PRICEFORTHREEMONTHS"><span className="real_price">5 990
                                        ₽</span></span><span className="additional PRICEFORYEAR"><span
                                            className="real_price">4 193 ₽</span><br /><span className="old_cena">5 990
                                        ₽</span></span><span className="additional PRICEFORTWOYEARS"><span
                                            className="real_price">3 594 ₽</span><br /><span className="old_cena">5 990
                                        ₽</span></span></div>
                                </td>
                            </tr>
                            <tr className="">
                                <th scope="row">Пользователи</th>
                                <td>50</td>
                            </tr>
                            <tr className="table__hidengs">
                                <th scope="row">CRM-Маркетинг&#65279;</th>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i><i className="fa fa-plus-circle"
                                    aria-hidden="true"></i></td>
                            </tr>
                            <tr className="table__hidengs">
                                <th scope="row">Сквозная аналитика&#65279;</th>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i><i className="fa fa-plus-circle"
                                    aria-hidden="true"></i></td>
                            </tr>
                            <tr className="table__hidengs">
                                <th scope="row">Центр продаж&#65279;</th>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i><i className="fa fa-plus-circle"
                                    aria-hidden="true"></i></td>
                            </tr>
                            <tr className="table__hidengs">
                                <th scope="row">Место в облаке</th>
                                <td>100 ГБ</td>
                            </tr>
                            <tr className="table__hidengs">
                                <th scope="row">Запись звонков</th>
                                <td>∞</td>
                            </tr>
                            <tr className="">
                                <th scope="row">CRM&#65279;</th>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i><i className="fa fa-plus-circle"
                                    aria-hidden="true"></i></td>
                            </tr>
                            <tr className="">
                                <th scope="row">Задачи и проекты&#65279;</th>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i><i className="fa fa-plus-circle"
                                    aria-hidden="true"></i></td>
                            </tr>
                            <tr className="">
                                <th scope="row">Офис, совместная работа&#65279;</th>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i><i className="fa fa-plus-circle"
                                    aria-hidden="true"></i></td>
                            </tr>
                            <tr className="table__hidengs">
                                <th scope="row">Сайты и лендинги&#65279;</th>
                                <td>10</td>
                            </tr>
                            <tr className="table__hidengs">
                                <th scope="row">Магазин&#65279;</th>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i><i className="fa fa-plus-circle"
                                    aria-hidden="true"></i></td>
                            </tr>
                            <tr className="table__hidengs">
                                <th scope="row">Контакт-Центр&#65279;</th>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i><i className="fa fa-plus-circle"
                                    aria-hidden="true"></i></td>
                            </tr>
                            <tr>
                                <td colSpan="2"><a href="#" className="table__hidengs-toggle">Показать все
                                характеристики</a></td>
                            </tr>
                            <tr>
                                <td colSpan="2"><button type="button" className="btn btn-buy" data-target="#advanced"
                                    data-form-field-type="Подробнее :Тариф Б24 Команда, "
                                    data-toggle="modal">Подробнее</button></td>
                            </tr>
                        </tbody>
                    </table>
                    <table className="table table-responsive d-lg-none d-xl-none d-md-none d-lg-none d-xl-none ">
                        <thead>
                            <tr>
                                <th>Компания</th>
                                <th><select className="form-control additional_price_control">
                                    <option data-class="PRICEFORMONTH" value="PRICEFORMONTH">на 1 месяц</option>
                                    <option data-class="PRICEFORTHREEMONTHS" value="PRICEFORTHREEMONTHS">на 3 месяца
                                </option>
                                    <option data-class="PRICEFORHALFAYEAR" value="PRICEFORHALFAYEAR">на полгода
                                </option>
                                    <option data-class="PRICEFORYEAR" value="PRICEFORYEAR">на год</option>
                                    <option data-class="PRICEFORTWOYEARS" value="PRICEFORTWOYEARS">на 2 года
                                </option>
                                </select></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th scope="row"><span className="custom_labels-header">Цена за месяц</span></th>
                                <td className="price_col"><span className="additional_wrapper"><span className="real_price">7 194
                                    ₽</span><br /><span className="old_cena">11 990 ₽</span></span>
                                    <div className="prices_box"><span className="additional PRICEFORMONTH"><span
                                        className="real_price">11 990 ₽</span></span><span
                                            className="additional PRICEFORTHREEMONTHS"><span className="real_price">11 990
                                        ₽</span></span><span className="additional PRICEFORYEAR"><span
                                            className="real_price">8 393 ₽</span><br /><span className="old_cena">11 990
                                        ₽</span></span><span className="additional PRICEFORTWOYEARS"><span
                                            className="real_price">7 194 ₽</span><br /><span className="old_cena">11 990
                                        ₽</span></span></div>
                                </td>
                            </tr>
                            <tr className="">
                                <th scope="row">Пользователи</th>
                                <td>∞</td>
                            </tr>
                            <tr className="table__hidengs">
                                <th scope="row">CRM-Маркетинг&#65279;</th>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i><i className="fa fa-plus-circle"
                                    aria-hidden="true"></i><i className="fa fa-plus-circle" aria-hidden="true"></i></td>
                            </tr>
                            <tr className="table__hidengs">
                                <th scope="row">Сквозная аналитика&#65279;</th>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i><i className="fa fa-plus-circle"
                                    aria-hidden="true"></i><i className="fa fa-plus-circle" aria-hidden="true"></i></td>
                            </tr>
                            <tr className="table__hidengs">
                                <th scope="row">Центр продаж&#65279;</th>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i><i className="fa fa-plus-circle"
                                    aria-hidden="true"></i><i className="fa fa-plus-circle" aria-hidden="true"></i></td>
                            </tr>
                            <tr className="table__hidengs">
                                <th scope="row">Место в облаке</th>
                                <td>∞</td>
                            </tr>
                            <tr className="table__hidengs">
                                <th scope="row">Запись звонков</th>
                                <td>∞</td>
                            </tr>
                            <tr className="">
                                <th scope="row">CRM&#65279;</th>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i><i className="fa fa-plus-circle"
                                    aria-hidden="true"></i><i className="fa fa-plus-circle" aria-hidden="true"></i></td>
                            </tr>
                            <tr className="">
                                <th scope="row">Задачи и проекты&#65279;</th>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i><i className="fa fa-plus-circle"
                                    aria-hidden="true"></i><i className="fa fa-plus-circle" aria-hidden="true"></i></td>
                            </tr>
                            <tr className="">
                                <th scope="row">Офис, совместная работа&#65279;</th>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i><i className="fa fa-plus-circle"
                                    aria-hidden="true"></i><i className="fa fa-plus-circle" aria-hidden="true"></i></td>
                            </tr>
                            <tr className="table__hidengs">
                                <th scope="row">Сайты и лендинги&#65279;</th>
                                <td>∞</td>
                            </tr>
                            <tr className="table__hidengs">
                                <th scope="row">Магазин&#65279;</th>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i><i className="fa fa-plus-circle"
                                    aria-hidden="true"></i><i className="fa fa-plus-circle" aria-hidden="true"></i></td>
                            </tr>
                            <tr className="table__hidengs">
                                <th scope="row">Контакт-Центр&#65279;</th>
                                <td><i className="fa fa-plus-circle" aria-hidden="true"></i><i className="fa fa-plus-circle"
                                    aria-hidden="true"></i><i className="fa fa-plus-circle" aria-hidden="true"></i></td>
                            </tr>
                            <tr>
                                <td colSpan="2"><a href="#" className="table__hidengs-toggle">Показать все
                                характеристики</a></td>
                            </tr>
                            <tr>
                                <td colSpan="2"><button type="button" className="btn btn-buy" data-target="#advanced"
                                    data-form-field-type="Подробнее :Тариф Б24 Компания, "
                                    data-toggle="modal">Подробнее</button></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="row oboznachenia">
                    <div className="col-md-3"><i className="fa fa-minus-circle" aria-hidden="true"></i>
                нет
            </div>
                    <div className="col-md-3"><i className="fa fa-plus-circle" aria-hidden="true"></i>
                базовый набор возможностей
            </div>
                    <div className="col-md-3"><i className="fa fa-plus-circle" aria-hidden="true"></i><i
                        className="fa fa-plus-circle" aria-hidden="true"></i>
                расширенный
            </div>
                    <div className="col-md-3"><i className="fa fa-plus-circle" aria-hidden="true"></i><i
                        className="fa fa-plus-circle" aria-hidden="true"></i><i className="fa fa-plus-circle"
                            aria-hidden="true"></i>
                профессиональный
            </div>
                </div>
            </div>
        </div>
    );
}

export default App;